<template>
    <span class="base-list-item-title">
        <slot></slot>
    </span>
</template>

<script>
export default {
    name: "BaseListItemTitle"
}
</script>

<style scoped>

</style>